import React, { useState } from 'react';
import { FaFilter } from 'react-icons/fa';
import './EventPageMobile.css';
import EventsPostLayout from '../Events/EventsPostLayout';
import FilterPanelMobile from "./FilterPanelMobile";
import SearchBarMobile from "../../../Components/SearchBarMobile/SearchBarMobile";

const EventPageMobile = () => {
  const [allPosts, setAllPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  return (
    <div className="e-market-container">
      {/* Header */}
      <header className="e-market-header">
        <div className="e-header-content">
          <h1 className="e-title-text">
            EVENT <span className="e-highlight">POSTS</span>
          </h1>
          <p className="e-subtitle-text">AUTOMOTIVE EVENTS</p>
        </div>
        <img
          src={`${process.env.PUBLIC_URL}/category-icons/event.png`}
          alt="Icon"
          className="e-header-logo"
        />
      </header>

      {/* Search */}
      <SearchBarMobile
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onOpenFilters={() => setShowFilters(true)}
      />

      {/* Promoted */}
      <div className="e-promoted-section">
        <h3 className="e-section-label">PROMOTED</h3>
        <div className="e-promoted-scroll">
          {allPosts.filter(p => p.tokens > 0).map(post => (
            <div key={post.id} className="e-card-promoted">
              <EventsPostLayout key={post.id} {...post} />
            </div>
          ))}
        </div>
      </div>

      {/* Feed */}
      <div className="e-main-feed">
        <h3 className="e-section-label">
          ALL LISTINGS ({filteredPosts.length})
        </h3>

        {filteredPosts.map(post => (
          <EventsPostLayout key={post.id} {...post} />
        ))}
      </div>

      {/* Filter Panel */}
      <FilterPanelMobile
        show={showFilters}
        onClose={() => setShowFilters(false)}
        searchQuery={searchQuery}
        setAllPosts={setAllPosts}
        setFilteredPosts={setFilteredPosts}
      />
    </div>
  );
};

export default EventPageMobile;